import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed, PropType } from 'vue';
import { withoutTrailingDot } from '@/common/domainName';
import { getRecordType, RecordTypesUnion } from '@/common/recordTypes';


export default /*@__PURE__*/_defineComponent({
  __name: 'DnsRecordsLink',
  props: {
  domain: {
    type: String,
    required: true,
  },
  page: {
    type: String as PropType<RecordTypesUnion | 'propagation' | 'webservers' | 'dns-records' | 'SPF'>,
    default: 'dns-records',
  },
},
  setup(__props) {

const props = __props;

const urlDomain = computed(() => withoutTrailingDot(props.domain));
const urlRecordType = computed(() => props.page?.toLowerCase());
const plural = computed(() => {
  if (!['propagation', 'webservers', 'dns-records'].includes(props.page)) {
    return getRecordType(props.page).plural;
  }
  return '';
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (__props.page === 'propagation')
    ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        to: `/domains/${urlDomain.value}/dns-propagation/a/`,
        title: `DNS propagation for ${__props.domain}`
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default", {}, () => [
            _createTextVNode(_toDisplayString(__props.domain), 1)
          ])
        ]),
        _: 3
      }, 8, ["to", "title"]))
    : (__props.page === 'dns-records')
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 1,
          to: `/domains/${urlDomain.value}/dns-records/`,
          title: `DNS records for ${__props.domain}`
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default", {}, () => [
              _createTextVNode(_toDisplayString(__props.domain), 1)
            ])
          ]),
          _: 3
        }, 8, ["to", "title"]))
      : (__props.page === 'webservers')
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 2,
            to: `/domains/${urlDomain.value}/webservers/`,
            title: `IP addresses for ${__props.domain}`
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default", {}, () => [
                _createTextVNode(_toDisplayString(__props.domain), 1)
              ])
            ]),
            _: 3
          }, 8, ["to", "title"]))
        : (__props.page === 'SPF')
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 3,
              to: `/domains/${urlDomain.value}/email/spf/`,
              title: `SPF record for ${__props.domain}`
            }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "default", {}, () => [
                  _createTextVNode(_toDisplayString(__props.domain), 1)
                ])
              ]),
              _: 3
            }, 8, ["to", "title"]))
          : (_openBlock(), _createBlock(_component_router_link, {
              key: 4,
              to: `/domains/${urlDomain.value}/dns-records/${urlRecordType.value}/`,
              title: `${plural.value} for ${__props.domain}`
            }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "default", {}, () => [
                  _createTextVNode(_toDisplayString(__props.domain), 1)
                ])
              ]),
              _: 3
            }, 8, ["to", "title"]))
}
}

})